import React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import { Button, Checkbox, Icon, Input, LoginScreen, ToggleSwitch, Tooltip, WithTooltip } from "@abb/abb-common-ux-react";
import * as CONSTANTS from "../../utilities/Constants";

import History from "../../utilities/History";
import loginActions from "../../flux/actions/LoginActions";
import licenseActions from "../../flux/actions/LicenseActions";
import { LoginFormData } from "../../models/login/loginFormData";
import triggerNotifications from "../../utilities/TriggerNotifications";
import loginFormStore from "../../flux/stores/login/LoginStore";
import getLicenseDetailsStore from "../../flux/stores/license/GetLicenseDetailsStore"
import auth from "../../utilities/Auth";
import * as ICONCONSTANTS from "../../utilities/IconConstants";

import { Translation } from "react-i18next";
import KeyCloakStatus from "./KeyCloakStatus";
import KeyCloakInitialSetup from "./KeyCloakInitialSetup";
import UserLogin from "./UserLogin";
import LicenseStatus from "./LicenseStatus";
import { ILicenseData, defaultLicenseData } from "../../models/license/licenseTypeData";
import uploadLicenseFileStore from "../../flux/stores/license/uploadLicenseFileStore";
import i18next from "i18next";

type PropsType = RouteComponentProps & {};

interface IState {
  loading: boolean;
  username: string;
  password: string;
  rememberMe: boolean;
  passwordVisible: boolean;
  isKeycloakLive: boolean;
  initialSetupCompleted: boolean;
  keycloakUsername: string;
  keycloakPassword: string;
  isManuallyConfigured: boolean;
  licenseExpired: boolean;
  expirationDate: string;
  licenseDetails: ILicenseData[];
  licenseFileData: any;
  isLicenseExists: boolean;
  isFileUploadFailed: boolean;
  file: any;
  isErrorFileType: boolean;
}

class Login extends React.Component<PropsType, IState> {
  _mount: boolean;
  _copyRightText = CONSTANTS.COPY_RIGHT_TEXT + " " + new Date().getFullYear();
  _isLogin: boolean = false;
  _loginDetails: any = null;

  constructor(props: PropsType) {
    super(props);
    this.state = {
      loading: true,
      username: "",
      password: "",
      rememberMe: false,
      passwordVisible: false,
      isKeycloakLive: false,
      initialSetupCompleted: false,
      keycloakUsername: "",
      keycloakPassword: "",
      isManuallyConfigured: false,
      licenseExpired: false,
      expirationDate: "",
      licenseDetails: [defaultLicenseData],
      licenseFileData: "",
      isLicenseExists: false,
      isFileUploadFailed: false,
      file: null,
      isErrorFileType: false
    };
  }

  onKeycloakLogin = (e: any) => {
    if (this.state.keycloakUsername !== "" && this.state.keycloakPassword !== "") {
      this.setState({ loading: true }, () => {
        const data = new LoginFormData(
          this.state.keycloakUsername,
          this.state.keycloakPassword
        );
        loginActions
          .keycloakLogin(data)
          .then((response: boolean) => {
            this.setState({ initialSetupCompleted: response, loading: false });
            if (!response) {
              triggerNotifications
                .error("something went wrong. please check credentials and try again / Try manual way of configuring!");
            }
          })
          .catch((error) => {
            this.setState({ loading: false },
              () =>
                triggerNotifications
                  .error(error?.error_description ?? "something went wrong...")
                  .then()
            );
          });
      });
    } else {
      triggerNotifications
        .info("Username and Password should not be empty")
        .then()
    }
  }
  onLogin = (e: any) => {
    if (this.state.username !== "" && this.state.password !== "") {
      this.setState({ loading: true }, () => {
        const data = new LoginFormData(
          this.state.username,
          this.state.password
        );
        loginActions
          .login(data)
          .then(async () => {
            if (this._isLogin && this._loginDetails) {
              if (this.state.rememberMe) {
                auth.setRememberMe(this.state.username, this.state.password);
              } else {
                auth.removeRemeberMe();
              }
              localStorage.setItem(CONSTANTS.HAS_LOGGED_OUT, 'true');
              await auth.setAccessToken(this._loginDetails.access_token);
              await auth.setRefreshToken(this._loginDetails.refresh_token);
              await auth.setUserName(this._loginDetails.userName);
              if (auth.getAccessToken()) {
                window.location.href = CONSTANTS.SAMPLE_INDEXNEW_URL;
              }
            } else {
              this.setState(
                {
                  loading: false,
                },
                () =>
                  triggerNotifications
                    .error(
                      this._loginDetails?.error_description ??
                      "something went wrong..."
                    )
                    .then()
              );
            }
          })
          .catch((error) => {
            this.setState(
              {
                loading: false,
              },
              () =>
                triggerNotifications
                  .error(error?.error_description ?? "something went wrong...")
                  .then()
            );
          });
      });
    } else {
      triggerNotifications
        .info("Username and Password should not be empty")
        .then()
    }
  }
  updateInitialSetupStatus = (status: boolean) => {
    this.setState({ loading: true }, () => {
      loginActions
        .SetInitialKeyCloakSetup(status)
        .then(async (response: boolean) => {
          this.setState({ initialSetupCompleted: response, loading: false })
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    });
  }
  checkIsKeyCloakStatus = () => {
    this.setState({ loading: true }, () => {
      loginActions
        .keyCloakHealthCheck()
        .then(async (response: boolean) => {
          this.setState({ isKeycloakLive: response, loading: false })
          if (response) {
            this.InitialKeyCloakSetup();
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    });
  }
  InitialKeyCloakSetup = () => {
    loginActions
      .InitialKeyCloakSetup()
      .then(async (response: boolean) => {
        this.setState({ initialSetupCompleted: response })
      })
      .catch((error) => {
      });
  }

  dateFormat = (date: string) => {
    let dateObj = new Date(date);
    return dateObj.toDateString();
  }

  getLicenseData = () => {
    this.setState({ loading: true }, () => {
      licenseActions
        .getLicenseDetails()
        .then(async () => {
          // Health Check keycloak
          this.checkIsKeyCloakStatus();
          this.InitialKeyCloakSetup();
          this.setState({ isLicenseExists: true, loading: false })
          let responses: any = this.state.licenseDetails?.filter((x: any) => x.isActive === true && x.hasValidLicense === true);
          const isAnyLicenseNotApplicable = this.state.licenseDetails?.some(node => !node.isLicenseApplicable);
          // let responses: any = await import('../../../public/test.json');
          // let isAnyLicenseNotApplicable:any = responses.default.some((node:any) => !node.isLicenseApplicable);
          // responses = responses.default.filter((x:any) => x.isActive === true && x.hasValidLicense === true);
          let expirationDate = this.state.licenseDetails?.filter((x: any) => x.licenseType === "Subscription");
          if(expirationDate.length !== 0){
            this.setState({ expirationDate: this.dateFormat(expirationDate[0].expiryDate) });
          }
          let response: any;
          if (isAnyLicenseNotApplicable) {
            this.setState({ licenseExpired: false });
          } else {
            if (responses) {
              response = responses[0];
            }
            if (response !== undefined) {
              if (responses?.length !== 0) {
                if (response?.isLicenseApplicable) {
                  if (response?.hasValidLicense) {
                    this.setState({ file: null })
                    if (!response?.isLifeTimeLicense) {
                      if (response?.expiryDate !== "") {
                        const date = new Date(response.expiryDate);
                        const currentDate = new Date();
                        if (date < currentDate) {
                          this.setState({ licenseExpired: true, expirationDate: this.dateFormat(response?.expiryDate), isLicenseExists: true })
                        } else {
                          this.setState({ licenseExpired: false, expirationDate: this.dateFormat(response?.expiryDate), isLicenseExists: true })
                        }
                      } else {
                        // triggerNotifications.error("Valid License not found");
                      }
                    } else {
                      this.setState({ licenseExpired: false });
                    }
                  } else {
                    this.setState({ licenseExpired: true, isLicenseExists: true });
                    if (response?.expiryDate !== "") {
                      this.setState({ expirationDate: this.dateFormat(response?.expiryDate) })
                    }
                    // triggerNotifications.error("Valid License not found");
                  }
                } else {
                  this.setState({ licenseExpired: false });
                }
              } else {
                this.setState({ licenseExpired: true });
              }
            } else {
              this.setState({ licenseExpired: true });
            }
          }
        })
        .catch((error) => {
          this.setState({ licenseExpired: true, isLicenseExists: false, loading: false });
        });
    });
  }
  componentDidMount(): void {
    loginFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._loginDetails = state;
      if (state.access_token && state.refresh_token && state.userName) {
        this._isLogin = true;
      }
    });

    getLicenseDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this.setState({ licenseDetails: state.licenseData.data });
    });

    uploadLicenseFileStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this.setState({ licenseFileData: state.licenseData.data });
    });

    this.getLicenseData();

    const remeber = auth.getRemberMe();
    if (remeber) {
      this.setState({
        username: remeber.username,
        password: remeber.password,
        rememberMe: true,
      });
    }
  }

  keycloakUsername = (name: string) => {
    this.setState({
      keycloakUsername: name,
    });
  }

  keycloakPassword = (password: string) => {
    this.setState({
      keycloakPassword: password,
    });
  }

  setUsername = (name: string) => {
    this.setState({
      username: name,
    });
  }

  setPassword = (password: string) => {
    this.setState({
      password: password,
    });
  }

  togglePasswordVisibility = () => {
    this.setState({
      passwordVisible: !this.state.passwordVisible
    });
  }

  toggleRememberMe = () => {
    this.setState({ rememberMe: !this.state.rememberMe });
  }

  handleFileUpload = (file: any) => {
    const formData = new FormData();
    formData.append('file', file);
    licenseActions
      .uploadLicenseFile(formData)
      .then(() => {
        let response: any = this.state.licenseFileData
        if (response && response === true) {
          triggerNotifications.success([i18next.t(CONSTANTS.FILE_UPLOAD_SUCCESS)]);
          this.setState({ licenseExpired: false, expirationDate: this.dateFormat(response?.expiryDate) })
          this.getLicenseData();
        } else {
          this.setState({ isFileUploadFailed: true })
          triggerNotifications.error(i18next.t(CONSTANTS.FILE_UPLOAD_FAILED));
        }
      })
      .catch((error) => {
        this.setState({ isFileUploadFailed: true, licenseExpired: true })
        triggerNotifications.error(error?.error_description ?? i18next.t(CONSTANTS.FILE_UPLOAD_FAILED));
      });
  }

  handleChange = (file: any) => {
    this.setState({ file: file, isFileUploadFailed: false, isErrorFileType: false })
  };

  onTypeError = (file: any) => {
    this.setState({ file, isErrorFileType: true, isFileUploadFailed: false });
  }

  public render() {
    console.log(this.state, "this.state")
    return (
      <Translation>
        {
          t =>
            <div style={{ margin: "25px auto" }}>
              <LoginScreen
                productName={t(CONSTANTS.PRODUCT_NAME)}
                productFullName={t(CONSTANTS.PRODUCT_NAME_WITH_VERSION)}
                footerText={t(CONSTANTS.LAW_TEXT)}
                copyrightText={t(CONSTANTS.COPY_RIGHT_TEXT) + " " + new Date().getFullYear()}
                loading={this.state.loading}
                showDefaultFields={false}
                showLoginButton={false}
                customContent={() => {
                  return (
                    <React.Fragment>
                      {(!this.state.licenseExpired && !this.state.isKeycloakLive && !this.state.initialSetupCompleted)
                        && <></>}
                      {this.state.licenseExpired &&
                        <LicenseStatus
                          expirationDate={this.state.expirationDate}
                          handleFileUpload={this.handleFileUpload}
                          isLicenseExists={this.state.isLicenseExists}
                          isFileUploadFailed={this.state.isFileUploadFailed}
                          handleChange={this.handleChange}
                          file={this.state.file}
                          licenseDetails={this.state.licenseDetails}
                          onTypeError={this.onTypeError}
                          isErrorFileType={this.state.isErrorFileType}
                        />}
                      {!this.state.isKeycloakLive && !this.state.licenseExpired &&
                        <KeyCloakStatus
                          checkIsKeyCloakStatus={this.checkIsKeyCloakStatus}
                        />}
                      {(!this.state.initialSetupCompleted && this.state.isKeycloakLive) && !this.state.licenseExpired &&
                        <KeyCloakInitialSetup
                          keycloakUsername={this.state.keycloakUsername}
                          keycloakPassword={this.state.keycloakPassword}
                          passwordVisible={this.state.passwordVisible}
                          updateInitialSetupStatus={this.updateInitialSetupStatus}
                          onKeycloakLogin={this.onKeycloakLogin}
                          setKeycloakUsername={this.keycloakUsername}
                          setKeycloakPassword={this.keycloakPassword}
                          togglePasswordVisibility={this.togglePasswordVisibility}
                        />}
                      {(this.state.initialSetupCompleted && this.state.isKeycloakLive && !this.state.licenseExpired) &&
                        <UserLogin
                          username={this.state.username}
                          password={this.state.password}
                          passwordVisible={this.state.passwordVisible}
                          rememberMe={this.state.rememberMe}
                          setUsername={this.setUsername}
                          setPassword={this.setPassword}
                          togglePasswordVisibility={this.togglePasswordVisibility}
                          toggleRememberMe={this.toggleRememberMe}
                          onLogin={this.onLogin}
                        />}
                    </React.Fragment>
                  );
                }}
              />
            </div>
        }
      </Translation>
    );
  }
}

export default withRouter(Login);
